import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

function Banner({ data, autoPlay = true, arrows = true, draggable = true }) {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 0 },
      items: 1,
    },
  };
  return (
    <article>
      <Carousel
        autoPlay={autoPlay}
        responsive={responsive}
        infinite={true}
        arrows={arrows}
        draggable={draggable}
      >
        {data.map((item, index) => {
          return (
            <img
              draggable="false"
              src={item}
              key={index}
              alt=""
              className="banner-img"
            />
          );
        })}
      </Carousel>
    </article>
  );
}

export default Banner;
